module.exports = __webpack_public_path__ + "static/media/S_Q.4aac8a8d.png";